import React from 'react';
import EntityTab from '../../controls/EntityTab';

export default function Workflows() {
    return <EntityTab entityType={'Workflows'} />;
}
